import UpgradeAccountValidatingDocuments from './UpgradeAccountValidatingDocuments';

export default UpgradeAccountValidatingDocuments;
